import { get, getRawValue } from '../../utils/get';
import { getKeys } from '../../adapters/utils';
import { getDynamicPatternsSchemaLegacy, getFullUrlLegacy, getLegacyData, hasMultilingualLegacy, setFullUrlLegacy, } from './get-data-legacy';
import { getData, getDynamicPatternsSchema, getFullUrl, hasMultilingual, setFullUrl, } from './get-data';
import { SD_STATUS } from '../../consts';
import { updateValueByIdentifier } from '../../tags/values/update-by-identifier';
import { IDENTIFIERS } from '../../types/Identifiers';
var IDs = {
    ID: 'blog-category.id',
    TITLE: 'blog-category.name',
    DESCRIPTION: 'blog-category.description',
    MAIN_IMAGE: 'blog-category.image',
    IMAGE_HEIGHT: 'blog-category.image.height',
    IMAGE_WIDTH: 'blog-category.image.width',
    PAGE_URL: 'blog-category.url',
    PREV_PAGE_URL: 'blog-category.prevUrl',
    NEXT_PAGE_URL: 'blog-category.nextUrl',
    CURRENT_PAGE: 'blog-category.currentPage',
    TOTAL_PAGE_COUNT: 'blog-category.totalPageCount',
    BLOG_FEED_ROUTE: 'blog-category.blogFeedRoute',
    LANGUAGE: 'blog-category.language',
};
var userVisible = [
    IDs.TITLE,
    IDs.TOTAL_PAGE_COUNT,
    IDs.CURRENT_PAGE,
    IDs.DESCRIPTION,
    IDs.PAGE_URL,
    IDs.MAIN_IMAGE,
];
var requiredSchemaVariables = [];
var SchemaTypes = {
    BLOG_CATEGORY_COLLECTION: 'blog-category-collection-preset',
};
var isLegacyItemType = function (item) {
    return Boolean(getRawValue(item, 'category.canonicalUrl'));
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        return isLegacyItemType(item)
            ? getLegacyData(IDs, item)
            : getData(IDs, item);
    },
    getSdStatus: function () { return SD_STATUS.DOES_NOT_EXIST; },
    getLegacySeoBlob: function (item) {
        var tags = updateValueByIdentifier([], IDENTIFIERS.TITLE, get(item, 'legacySeoData.title'));
        tags = updateValueByIdentifier(tags, IDENTIFIERS.DESCRIPTION, get(item, 'legacySeoData.description'));
        return { tags: tags };
    },
    getDynamicPatternsSchema: function (item) {
        return isLegacyItemType(item)
            ? getDynamicPatternsSchemaLegacy(item)
            : getDynamicPatternsSchema(item);
    },
    getSlug: function (item) { return get(item, 'category.slug'); },
    setFullUrl: function (item, url) {
        if (url === void 0) { url = ''; }
        return isLegacyItemType(item)
            ? setFullUrlLegacy(item, url)
            : setFullUrl(item, url);
    },
    getFullUrl: function (item) {
        return isLegacyItemType(item) ? getFullUrlLegacy(item) : getFullUrl(item);
    },
    updateItemDataWithSlug: function (item) { return item; },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return []; },
    hasMultilingual: function (item) {
        return isLegacyItemType(item)
            ? hasMultilingualLegacy(item)
            : hasMultilingual(item);
    },
};
